<template>
    <section>
        <div class="contacts__wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>
                    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                        <h4 data-aos-duration="2000" data-aos="fade" class="contact-title">Contact Cibeez </h4>
                        <div data-aos-duration="3000" data-aos="fade" class="contact-form row">
                            <div class="form-field col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <input id="first_name"
                                       v-model="first_name"
                                       placeholder="First Name"
                                       class="input-text js-input"
                                       type="text">
                            </div>
                            <div class="form-field  col-sm-12 col-md-4  col-lg-4 col-xl-4">
                                <input id="last_name"
                                       v-model="last_name"
                                       placeholder="Last Name"
                                       class="input-text js-input"
                                       type="text">
                            </div>
                            <div class="form-field col-sm-12 col-md-4  col-lg-4 col-xl-4">
                                <input id="email"
                                       v-model="email"
                                       placeholder="Email"
                                       class="input-text js-input"
                                       type="email"
                                       name="email"
                                       :data-vv-as="'E-Mail'"
                                       v-validate="'email|required'"
                                       v-bind:class=" errors.any() ? 'border-error' : ''">
                                <small class="form-text text-danger" v-if="errors.has('email')">
                                    {{ errors.first('email') }}
                                </small>
                            </div>
                            <div class="form-field col-sm-12 col-md-4  col-lg-4 col-xl-4">
                                <input id="company_name"
                                       v-model="company_name"
                                       placeholder="Company Name"
                                       class="input-text js-input"
                                       type="text">
                            </div>
                            <div class="form-field col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                <input id="message"
                                       v-model="message"
                                       placeholder="Type your message here..."
                                       class="input-text js-input"
                                       type="text">
                            </div>
                        </div>
                        <div data-aos-duration="3000" data-aos="fade" class="button-form">
                            <button :disabled="errors.has('email')" @click="sendMail()" class="submit-style">Submit</button>
                        </div>
                        <div data-aos-duration="3000" data-aos="fade" class="ltd">
                            <h1>Cibeez (Israel) Ltd.</h1>
                        </div>
                        <div data-aos-duration="3000" data-aos="fade" class="at-contact">
                            <span>Contact Cibeez at :</span> <a
                                href="mailto:contactus@cibeez.com">contactus@cibeez.com</a>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
    /* eslint-disable no-console */

    export default {
        data() {
            return {
                first_name: '',
                last_name: '',
                email: '',
                company_name: '',
                message: ''
            };
        },

        methods: {
            async sendMail() {
                const isValid = await this.$validator.validateAll();
                if (!isValid) {
                   return;
                }
                    const formdata = new FormData;
                    formdata.append('first_name', this.first_name);
                    formdata.append('last_name', this.last_name);
                    formdata.append('email', this.email);
                    formdata.append('company_name', this.company_name);
                    formdata.append('message', this.message);
                    const response = await this.axios.post('./Mail.php', formdata);
                    if (response.status) {
                        this.$toast.open('Message sent');
                        this.resetForms();
                    }

            },
            resetForms() {
                this.first_name = null;
                this.last_name = null;
                this.email = null;
                this.company_name = null;
                this.message = null;
                this.$validator.reset()
            }
        }
    }
</script>
